"use strict";
import { randomString } from "../utils";
const clickHandlers = /* @__PURE__ */ new Map();
if (typeof document !== "undefined") {
  document.addEventListener("click", (event) => {
    clickHandlers.forEach((handler) => {
      handler(event);
    });
  });
}
export default class OnClickOutside {
  constructor(ignoreElems, onClickOutside) {
    this.onClickOutside = onClickOutside;
    this.handlerId = randomString();
    this.ignoreElemsSelector = ignoreElems.join(",");
  }
  /*
    We make the stop / start listeners public so that we can instantiate this class once
    for a relevant piece of DOM and attach and remove listeners as its added and removed
    from the DOM.
  */
  startListening() {
    clickHandlers.set(this.handlerId, (event) => {
      if (this.outsideIgnorableElems(event.target)) {
        this.stopListening();
        return this.onClickOutside();
      }
    });
  }
  /**
   * @NOTE(blambo, 2019-06-19): Since we use delegated listeners, if we remove the
   * relevant DOM then we want to kill the listeners we created. So we provide this
   * programmatic access so that the caller can destroy the listeners.
   */
  stopListening() {
    clickHandlers.delete(this.handlerId);
  }
  // Determines if click event's target was OUTSIDE of the ignored elements.
  outsideIgnorableElems(target) {
    return !target.matches(this.ignoreElemsSelector) && this.parents(target, this.ignoreElemsSelector).length === 0;
  }
  parents(element, selector) {
    const parents = [];
    let node = element;
    do {
      node = node.parentNode;
      if (node instanceof Element && selector && node.matches(selector)) {
        parents.push(node);
      }
    } while (node && node !== document);
    return parents;
  }
}
